// Line icons for the Security card's status tiles. Phosphor has a door and a
// bulb but no house window, so all three are drawn here as one matched set.

// Icons fill their box, so the tile sizes them per breakpoint.
function LineIcon({ children }: { children: React.ReactNode }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="block w-full h-full"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export function DoorLineIcon() {
  return (
    <LineIcon>
      <path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17" />
      <path d="M3 21h18" />
      <path d="M14.5 12h.01" />
    </LineIcon>
  );
}

export function WindowLineIcon() {
  return (
    <LineIcon>
      <rect x="4" y="3" width="16" height="18" rx="1.5" />
      <path d="M12 3v18M4 12h16" />
    </LineIcon>
  );
}

export function BulbLineIcon() {
  return (
    <LineIcon>
      <path d="M9 18h6M10 21h4" />
      <path d="M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2V16h5v-.1c0-.8.4-1.5 1-2A6 6 0 0 0 12 3z" />
    </LineIcon>
  );
}
